<template>
  <div class="notification-item" @click="!!item.hasLink ? emitId('visit', item) : ''" :style="!!item.hasLink ? 'cursor: pointer' : ''">
    <div class="notification-body">
      <div class="notification-title">
        {{ item.title }}
      </div>
      <div class="notification-description">
        <p>{{ item.description }}</p>
      </div>
    </div>
    <div class="notification-actions text-right">
      <v-btn text color="primary" @click.s.stop="emitId('dismiss', item)">
        Dismiss
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  methods: {
    emitId (event, item) {
      this.$emit(event, item.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/app.variables";

.dismiss-btn {
  text-transform: uppercase;
  font-weight: 500;
  transition: color 0.3s ease;

  &:hover {
    color: $primary !important;
  }
}

.notification-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
  box-shadow: 0 3px 2px 0 rgba(0, 0, 0, 0.02);
  margin: 5px 5px 10px 5px;
  padding: 0 16px;
  transition: background 0.3s ease;
  &:hover {
    background: darken(white, 2%);
  }

  .notification-title {
    padding-top: 5px;
    font-size: 16px;
    color: black;
  }

  .notification-description {
    font-size: 14px;

    p {
      display: -webkit-box;
      -webkit-line-clamp: 12;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

  }
}
</style>
